<template>
  <div v-if="Reservation.status == 'ASSIGNED' || Reservation.status == 'PICKING_UP'" class="bottom-cancel">
    <p @click="openConfirmDialog">予約をキャンセルする</p>

    <DialogCancelConfirm ref="DialogConfirm" :onClickCancel="cancel" />
    <DialogCancelLoading ref="DialogLoading" />
    <DialogCancelComplete ref="DialogComplete" />
    <DialogCancelError ref="DialogError" />
  </div>
</template>

<script>
import { ref } from "vue";
import API from "@/API";

export default {
  name: "TheDemandBottomCancel",
  props: {
    Reservation: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const DialogConfirm = ref(null);
    const DialogLoading = ref(null);
    const DialogComplete = ref(null);
    const DialogError = ref(null);

    const openConfirmDialog = () => {
      DialogConfirm.value.openDialog();
    };

    const cancel = async () => {
      DialogConfirm.value.closeDialog();
      DialogLoading.value.openDialog();

      try {
        await API.getDemandToken(1);
        console.log("props.Reservation :>> ", props.Reservation);
        const apiParams = {
          id: props.Reservation.id,
          master_bookingservice_id: 1
        };
        await API.putDeleteReservation(apiParams);
        DialogLoading.value.closeDialog();
        DialogComplete.value.openDialog();
      }
      catch (e) {
        console.log(e);
        DialogLoading.value.closeDialog();
        DialogError.value.openDialog();
      }
    };

    return {
      DialogConfirm,
      DialogLoading,
      DialogComplete,
      DialogError,
      openConfirmDialog,
      cancel,
    };
  },
};
</script>

<style lang="scss" scoped>
.bottom-cancel {
  position: absolute;
  bottom: 0;
  height: 42px;
  width: calc(100% - 2px - 1%);
  margin: auto;
  left: 0.5%;
  border: 1px solid #e2e2e2;
  border-radius: 0px 0px 10px 10px;
  background: white;
  z-index: 1;

  p {
    text-align: center;
    color: #afafaf;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    font-size: 13px;
  }
}
</style>
